import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { className: "connect-page__content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, "Working on it, please wait...", -1)
const _hoisted_3 = { class: "social-connect__error-title" }

import TheHeader from '@/components/TheHeader.vue';
import { useDataStore } from '@/stores/data';
import { useFacebookStore } from '@/stores/facebook';
import { useInstagramStore } from '@/stores/instagram';
import { useTiktokStore } from '@/stores/tiktok';
import { parseQuery } from '@/utils/api-utils';
import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import VLoader from '@/components/VLoader.vue'
import VButton from '@/components/VButton.vue';
import { useDialogStore } from '@/stores/dialogs';
import AlreadyConnectedDialog from '@/components/dialogs/AlreadyConnectedDialog.vue';
import ConnectSocialConfirmDialog from '@/components/dialogs/ConnectSocialConfirmDialog.vue';
import FacebookRightsAlert from '@/components/dialogs/FacebookRightsAlert.vue';
import SettingsDialog from '@/components/dialogs/SettingsDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SocialConnect',
  setup(__props) {

const error = ref<string | null>(null)
const router = useRouter()

const facebookStore = useFacebookStore()
const instagramStore = useInstagramStore()
const tiktokStore = useTiktokStore()

const dataStore = useDataStore()

const title = computed(() => {
  if (router.currentRoute.value.name === "FacebookConnect") return "Facebook Connect"
  if (router.currentRoute.value.name === "InstagramConnect") return "Instagram Connect"
  if (router.currentRoute.value.name === "TiktokConnect") return "Tiktok Connect"
  return "Social Connect"
})

const dialogStore = useDialogStore()

onMounted(async () => {
  const obj = parseQuery(window.location.search)
  if (obj.error === "access_denied") {
    router.push("/")
    return
  }
  if (typeof obj.code !== "string" || typeof obj.state !== "string") {
    error.value = "Invalid link"
    return
  }
  const body = { code: obj.code, state: obj.state }
  
  if (router.currentRoute.value.name === "FacebookConnect") {
    dataStore.lockFacebookRequest = true
    try {
      const resp = await facebookStore.confirmConnectFacebook(body)
      dataStore.lockFacebookRequest = false
      router.push("/")
      if (resp.permissions === false) {
        dialogStore.open(FacebookRightsAlert, { permissions: resp.permissions_list })
        return
      }
      if (resp.already === true) {
        dialogStore.open(AlreadyConnectedDialog, { type: "facebook" })
        return
      }
      if (resp.is_already_connected_businesses === true) {
        dialogStore.open(ConnectSocialConfirmDialog, { type: "facebook", items: resp.facebook.businesses.elements, is_already_connected_businesses: resp.is_already_connected_businesses, already_connected_businesses: resp.already_connected_businesses })
        return
      }
      
      await dataStore.requestBusinesses()
      dialogStore.open(SettingsDialog, { page: "social" })
    } catch(e: any) {
      error.value = e.body?.message || "Something went wrong"
      dataStore.lockFacebookRequest = false
    } 
  }
  if (router.currentRoute.value.name === "InstagramConnect") {
    dataStore.lockFacebookRequest = true
    try {
      const resp = await instagramStore.confirmConnectInstagram(body)
      dataStore.lockFacebookRequest = false
      router.push("/")
      if (resp.permissions === false) {
        dialogStore.open(FacebookRightsAlert, { permissions: resp.permissions_list })
        return
      }
      if (resp.already === true) {
        dialogStore.open(AlreadyConnectedDialog, { type: "facebook" })
        return
      }
      if (resp.is_already_connected_businesses === true) {
        dialogStore.open(ConnectSocialConfirmDialog, { type: "facebook", items: resp.facebook.businesses.elements, is_already_connected_businesses: resp.is_already_connected_businesses, already_connected_businesses: resp.already_connected_businesses })
        return
      }
      
      await dataStore.requestBusinesses()
      dialogStore.open(SettingsDialog, { page: "social" })
    } catch(e: any) {
      error.value = e.body?.message || "Something went wrong"
      dataStore.lockFacebookRequest = false
    } 
  }
  if (router.currentRoute.value.name === "TiktokConnect") {
    dataStore.lockTiktokRequest = true
    try {
      const resp = await tiktokStore.confirmConnectTiktok(body)
      dataStore.lockTiktokRequest = false
      router.push("/")
      if (resp.already === true) {
        dialogStore.open(AlreadyConnectedDialog, { type: "tiktok" })
      }
      await dataStore.requestBusinesses()
    } catch(e: any) {
      error.value = e.body?.message || "Something went wrong"
      dataStore.lockTiktokRequest = false
    } 
  }
})

const goBack = () => {
  router.push("/")
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TheHeader, { title: _unref(title) }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      (!error.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(VLoader),
            _hoisted_2
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_3, "Error: " + _toDisplayString(error.value), 1),
            _createVNode(VButton, {
              class: "mt-2",
              onClick: goBack
            }, {
              default: _withCtx(() => [
                _createTextVNode("Go back")
              ]),
              _: 1
            })
          ], 64))
    ])
  ], 64))
}
}

})